module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gray-back",
    staticStyle: {
      "padding": ".2rem 0 1rem 0"
    }
  }, [_c('van-cell-group', [_c('van-cell', {
    attrs: {
      "title": "单位",
      "value": _vm.row.danwei
    }
  }), _vm._v(" "), _c('van-cell', {
    attrs: {
      "title": "联系人",
      "value": _vm.row.ldname
    }
  }), _vm._v(" "), _c('van-cell', {
    attrs: {
      "title": "微信号",
      "value": _vm.row.weixin
    }
  }), _vm._v(" "), _c('van-cell', {
    attrs: {
      "title": "手机号",
      "value": _vm.row.phone
    }
  }), _vm._v(" "), _c('van-cell', {
    attrs: {
      "title": "邮箱",
      "value": _vm.row.email
    }
  }), _vm._v(" "), _c('van-cell', {
    attrs: {
      "title": "省市",
      "value": _vm.row.county ? _vm.row.province + '/' + _vm.row.city + '/' + _vm.row.county : ''
    }
  }), _vm._v(" "), _c('van-cell', {
    attrs: {
      "title": "地址",
      "value": _vm.row.address
    }
  }), _vm._v(" "), _c('van-cell', {
    attrs: {
      "title": "报名状态"
    }
  }, [(_vm.row.memberstatus == 1) ? _c('div', [_vm._v("联系人信息")]) : (_vm.row.memberstatus == 2) ? _c('div', [_vm._v("人员信息")]) : (_vm.row.memberstatus == 3) ? _c('div', [_vm._v("申报信息")]) : (_vm.row.memberstatus == 4) ? _c('div', [_vm._v("确认订单")]) : (_vm.row.memberstatus == 6) ? _c('div', [_vm._v("报名成功")]) : _vm._e()])], 1), _vm._v(" "), _vm._l((_vm.row.member_list), function(item, index) {
    return _c('div', [_c('van-divider', [_vm._v("人员信息" + _vm._s(index + 1))]), _vm._v(" "), _c('van-cell-group', [_c('van-cell', {
      attrs: {
        "title": "姓名",
        "value": item.name
      }
    }), _vm._v(" "), _c('van-cell', {
      attrs: {
        "title": "性别",
        "value": item.sex
      }
    }), _vm._v(" "), _c('van-cell', {
      attrs: {
        "title": "身份证号",
        "value": item.num
      }
    }), _vm._v(" "), _c('van-cell', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.chengji),
        expression: "item.chengji"
      }],
      attrs: {
        "title": "成绩",
        "value": item.chengji
      }
    }), _vm._v(" "), _c('van-cell', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.cpj_chengji),
        expression: "item.cpj_chengji"
      }],
      attrs: {
        "title": "裁判长成绩",
        "value": item.cpj_chengji
      }
    }), _vm._v(" "), _c('van-cell', {
      attrs: {
        "title": "电话",
        "value": item.phone
      }
    }), _vm._v(" "), _c('van-cell', {
      attrs: {
        "title": "微信",
        "value": item.weixin
      }
    }), _vm._v(" "), _c('van-cell', {
      attrs: {
        "title": "套餐",
        "value": '(' + item.service_name + ')' + ' ¥' + item.price
      }
    })], 1)], 1)
  }), _vm._v(" "), _c('van-divider', [_vm._v("发票信息")]), _vm._v(" "), _c('van-cell', {
    attrs: {
      "title": "抬头",
      "value": _vm.row.fapiao_taitou
    }
  }), _vm._v(" "), _c('van-cell', {
    attrs: {
      "title": "税号",
      "value": _vm.row.fapiao_shuihao
    }
  }), _vm._v(" "), _c('van-cell', {
    attrs: {
      "title": "发票备注",
      "value": _vm.row.fapiao_beizhu
    }
  }), _vm._v(" "), _c('van-cell', {
    attrs: {
      "title": "接收邮箱",
      "value": _vm.row.fapiao_email
    }
  }), _vm._v(" "), _c('van-cell', {
    attrs: {
      "title": "接收手机",
      "value": _vm.row.fapiao_phone
    }
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0764b02e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/weiyuanhui/apps/huiyi/HuiyiApplyDetail.vue
// module id = 2190
// module chunks = 0